var map = {
	"./airplane.png": 12427,
	"./camera-with-flash.png": 35458,
	"./camera.png": 22632,
	"./cityscape.png": 71636,
	"./eyes.png": 11499,
	"./fire.png": 78441,
	"./hugging-face.png": 69668,
	"./partying-face.png": 68935,
	"./revolving-hearts.png": 85983,
	"./smiling-face-with-heart.png": 81068,
	"./speech-balloon.png": 82533,
	"./sun.png": 66615,
	"./thinking-face.png": 70767,
	"./woman-and-man-holding-hands.png": 5599,
	"./woman-dancing.png": 92744,
	"./woman-elf.png": 43151,
	"./woman-standing.png": 298,
	"./wrapped-gift.png": 59715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24950;